window.VCA = window.VCA || {};

window.VCA.checkoutConfirmationDataLayer = (function ($) {

    var ui = {};

    function cacheUI() {
        ui.$orderInfo = $('.js-checkout-order-info');
        ui.$orderCard = $('.js-checkout-order-card');
    }

    let checkoutOrderDetails = {
        'event': '',
        'paymentType': '',
        'currencyCode': '',
        'transactionId': '',
        'revenue': '',
        'shipping': '',
        'tax': '',
        'coupon': '',
        'refills': '',
        'subscription': '',
        'customerType': '',
        'action': '',
        'products': []
    }


    function initCheckoutConfirmationOrderDetails() {
        if (ui.$orderInfo.length <= 0) {
            return;
        }

        checkoutOrderDetails.event = ui.$orderInfo.data('item-event');
        checkoutOrderDetails.paymentType = ui.$orderInfo.data('item-paymenttype');
        checkoutOrderDetails.currencyCode = ui.$orderInfo.data('item-currencycode');
        checkoutOrderDetails.transactionId = ui.$orderInfo.data('item-transactionid');
        checkoutOrderDetails.revenue = ui.$orderInfo.data('item-revenue');
        checkoutOrderDetails.shipping = ui.$orderInfo.data('item-shipping');
        checkoutOrderDetails.tax = ui.$orderInfo.data('item-tax');
        checkoutOrderDetails.coupon = ui.$orderInfo.data('item-coupon');
        checkoutOrderDetails.subscription = ui.$orderInfo.data('item-subscription');
        checkoutOrderDetails.customerType = ui.$orderInfo.data('item-customertype');
        checkoutOrderDetails.action = ui.$orderInfo.data('item-action');
        checkoutOrderDetails.refills = ui.$orderInfo.data('item-refills');


        ui.$orderCard.each(function () {

            let id = $(this).data('item-id');
            let variant = $(this).data('item-variant');
            let name = $(this).data('item-name');
            let brand = $(this).data('item-brand');
            let category = $(this).data('item-category');
            let price = $(this).data('item-price');
            let quantity = $(this).data('item-quantity');
            let dimension89 = $(this).data('item-dimension89');
            let dimension90 = $(this).data('item-dimension90');
            let dimension94 = $(this).data('item-dimension94');
            let dimension104 = $(this).data('item-dimension104');
            let dimension106 = $(this).data('item-dimension106');
            let dimension107 = $(this).data('item-dimension107');
            let dimension108 = $(this).data('item-dimension108');

            checkoutOrderDetails.products.push({
                'id': id,
                'variant': variant,
                'name': name,
                'brand': brand,
                'category': category,
                'price': price,
                'quantity': quantity,
                'dimension89': dimension89,
                'dimension90': dimension90,
                'dimension94': dimension94,
                'dimension104': dimension104,
                'dimension106': dimension106,
                'dimension107': dimension107,
                'dimension108': dimension108
            });
        });

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': checkoutOrderDetails.event,
            'paymentType': checkoutOrderDetails.paymentType,
            'ecommerce': {
                'currencyCode': checkoutOrderDetails.currencyCode,
                'purchase': {
                    'actionField': {
                        'id': checkoutOrderDetails.transactionId,
                        'revenue': checkoutOrderDetails.revenue,
                        'shipping': checkoutOrderDetails.shipping,
                        'tax': checkoutOrderDetails.tax,
                        'coupon': checkoutOrderDetails.coupon,
                        'refills': checkoutOrderDetails.refills,
                        'subscription': checkoutOrderDetails.subscription,
                        'customer_type': checkoutOrderDetails.customerType,
                        'action': checkoutOrderDetails.action
                    },
                    'products': checkoutOrderDetails.products
                }
            }
        });
    }

    function init() {
        if ($('#checkoutConfirmationDetails').length <= 0) {
            return;
        }
        cacheUI();
        initCheckoutConfirmationOrderDetails();
    }

    return {
        init: init
    };



})(jQuery);

$(function () {
    VCA.checkoutConfirmationDataLayer.init();
});